import React from 'react';
import { SystemTemplateCard } from './SystemTemplateCard';
import { useSystemMessageTemplates } from '@/hooks/useSystemMessageTemplates';
import { Loader2 } from 'lucide-react';

export function SystemTemplatesTab() {
  const { data: templates, isLoading, isError, refetch } = useSystemMessageTemplates();

  if (isLoading) {
    return (
      <div className="p-4 space-y-4">
        {[...Array(4)].map((_, index) => (
          <div
            key={index}
            className="bg-white rounded-xl p-5 shadow-sm animate-pulse"
          >
            <div className="h-4 bg-gray-200 rounded w-1/3 mb-2" />
            <div className="h-3 bg-gray-200 rounded w-2/3" />
          </div>
        ))}
      </div>
    );
  }

  if (isError) {
    return (
      <div className="p-4">
        <div className="bg-white rounded-xl shadow-sm p-6 text-center">
          <h3 className="text-lg font-semibold text-[#212121] mb-2">
            Unable to load templates
          </h3>
          <p className="text-gray-600 mb-4">
            Please check your connection and try again.
          </p>
          <button
            onClick={() => refetch()}
            className="bg-[#5B8E87] text-white px-6 py-3 rounded-xl font-semibold hover:bg-[#4F7A74] transition-colors"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 space-y-4">
      <SystemTemplateCard messageType="appointment_confirmation" />
      <SystemTemplateCard messageType="appointment_reminder" />
      <SystemTemplateCard messageType="payment_reminder" />
      <SystemTemplateCard messageType="payment_received" />
    </div>
  );
}
